var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorrectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 11,
    viewBox: "0 0 16 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7304 0.31701C16.1076 0.720412 16.0864 1.35322 15.683 1.73043L6.058 10.7304C5.6736 11.0899 5.0764 11.0899 4.69201 10.7304L0.31701 6.63952C-0.0863925 6.26231 -0.107628 5.6295 0.269579 5.2261C0.646787 4.8227 1.2796 4.80146 1.683 5.17867L5.375 8.63094L14.317 0.269579C14.7204 -0.107628 15.3532 -0.0863925 15.7304 0.31701Z",
    fill: "#6BE394"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrectIcon);
export default __webpack_public_path__ + "static/media/correct-icon.610a460a785c4f0a989ed788695935a1.svg";
export { ForwardRef as ReactComponent };